export default __webpack_public_path__ + "media/images/logo-baf424e153471c05ea2e9087d26d8e60.svg";